/**
 * kalkulator.js
 * Árkalkulátor oldal interakció
 *
 * Fő funkciók:
 *  - Termék kiválasztása → méret opciók megjelenítése
 *  - Méret + darabszám változás → AJAX ár számítás
 *  - Mennyiségi kedvezmény táblázat frissítése
 *  - Több termék hozzáadása (klón)
 */

(function ($) {
    'use strict';

    const PRICE_URL = $('#kalkulatorApp').data('price-url') || '/kalkulator/price';
    const LOCALE = $('#kalkulatorApp').data('locale') || 'hu';

    // Formatálás
    function formatPrice(amount, currency) {
        if (!amount) return '–';
        if (currency === 'HUF') {
            return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 }).format(amount);
        }
        return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: currency || 'EUR', minimumFractionDigits: 2 }).format(amount);
    }

    // --- Méret sorok generálása (méretenként qty input) ---
    function buildSizeRows($card, sizes) {
        const $sizesSection = $card.find('.js-sizes-section');
        const $container    = $card.find('.js-size-rows-container');

        if (!sizes || sizes.length === 0) {
            // Nincs meretinformacio: 1 db mennyiseg-sor meretcimke nelkul
            $container.empty();
            const $row = $('<div>', { class: 'kalk-size-row' });
            const $qtyWrap = $('<div>', { class: 'kalk-size-row__qty' });
            $qtyWrap.append(
                $('<button>', { type: 'button', class: 'kalk-qty-btn js-size-qty-minus', 'data-size': '', text: '-' }),
                $('<input>', { type: 'number', class: 'kalk-qty-input js-size-qty-input', 'data-size': '', value: 1, min: 1, max: 9999 }),
                $('<button>', { type: 'button', class: 'kalk-qty-btn js-size-qty-plus', 'data-size': '', text: '+' })
            );
            const $price = $('<span>', { class: 'kalk-size-row__price' });
            $row.append($qtyWrap, $price);
            $container.append($row);
            $sizesSection.removeClass('d-none');
            return;
        }

        $container.empty();
        sizes.forEach(function (size) {
            const $row     = $('<div>', { class: 'kalk-size-row' });
            const $label   = $('<span>', { class: 'kalk-size-row__label', text: size });
            const $qtyWrap = $('<div>',  { class: 'kalk-size-row__qty' });
            $qtyWrap.append(
                $('<button>', { type: 'button', class: 'kalk-qty-btn js-size-qty-minus', 'data-size': size, text: '−' }),
                $('<input>',  { type: 'number', class: 'kalk-qty-input js-size-qty-input', 'data-size': size, value: 0, min: 0, max: 9999 }),
                $('<button>', { type: 'button', class: 'kalk-qty-btn js-size-qty-plus',  'data-size': size, text: '+' })
            );
            const $price = $('<span>', { class: 'kalk-size-row__price' });
            $row.append($label, $qtyWrap, $price);
            $container.append($row);
        });

        $sizesSection.removeClass('d-none');
    }

    // --- Ár számítás AJAX ---
    function triggerCalculation($card) {
        const productId = $card.find('.js-product-select').val();
        if (!productId) return;

        // Méretenként gyűjtsünk darabszámokat
        const sizes = {};
        $card.find('.js-size-qty-input').each(function () {
            const qty = parseInt($(this).val(), 10) || 0;
            if (qty > 0) {
                sizes[$(this).data('size')] = qty;
            }
        });
        const totalQty = Object.values(sizes).reduce((a, b) => a + b, 0);

        $.ajax({
            url: PRICE_URL,
            method: 'POST',
            data: {
                product_id: productId,
                sizes: sizes,
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            success: function (data) {
                updatePriceDisplay($card, data, data.total_qty || totalQty);
            },
        });
    }

    // --- Ár megjelenítés frissítése ---
    function updatePriceDisplay($card, data, quantity) {
        const $summary = $card.closest('#kalkulatorItems').siblings('.kalk-summary-card, .js-summary-card').first();

        // Per-meret egysegar frissitese a sorokban
        if (data.size_prices && data.size_prices.length) {
            data.size_prices.forEach(function (sp) {
                $card.find('.js-size-qty-input[data-size="' + sp.size + '"]')
                    .closest('.kalk-size-row')
                    .find('.kalk-size-row__price')
                    .text(formatPrice(sp.unit_price, sp.currency));
            });
        }

        // Preview ar
        var firstPrice = (data.size_prices && data.size_prices[0])
            ? formatPrice(data.size_prices[0].unit_price, data.size_prices[0].currency)
            : formatPrice(data.unit_price, data.currency);
        $card.find('.js-preview-price').text(firstPrice);

        // Osszesito kartya
        if ($summary.length) {
            $summary.find('.js-summary-price').text(firstPrice);
            $summary.removeClass('d-none');
            $summary.find('.js-summary-discount').text(data.discount_pct > 0 ? '-' + data.discount_pct + '% kedvezmeny' : '');
        }

        // Mennyisegi kedvezmeny tablazat
        updateDiscountTable(data, quantity);
    }

    // --- Kedvezmény táblázat ---
    function updateDiscountTable(data, currentQty) {
        const $wrap = $('.kalk-discount-table-wrap');
        if (!$wrap.length) return;

        const table = data.discount_table;
        if (!table || Object.keys(table).length === 0) {
            $wrap.html('<p class="text-muted small">' + (LOCALE === 'hu' ? 'Ehhez a termékhez nincs mennyiségi kedvezmény.' : 'No volume discount for this product.') + '</p>');
            return;
        }

        const colQty = LOCALE === 'hu' ? 'Darab' : 'Quantity';
        const colPct = LOCALE === 'hu' ? 'Kedvezmény' : 'Discount';
        const colPrice = LOCALE === 'hu' ? 'Egységár' : 'Unit price';

        let html = '<table class="kalk-discount-table"><thead><tr>';
        html += '<th>' + colQty + '</th><th>' + colPct + '</th>';
        html += '</tr></thead><tbody>';

        const tiers = Object.entries(table).sort(([a], [b]) => parseInt(a) - parseInt(b));
        tiers.forEach(function ([qty, pct]) {
            const isActive = parseInt(qty) <= currentQty;
            const tr = isActive ? '<tr class="kalk-tier--active">' : '<tr>';
            html += tr + '<td>' + qty + ' db</td><td>-' + pct + '%</td></tr>';
        });

        html += '</tbody></table>';
        $wrap.html(html);
    }

    // --- Step sáv frissítés ---
    function updateSteps(step) {
        $('.kalk-step').removeClass('kalk-step--active');
        $('.kalk-step[data-step="' + step + '"]').addClass('kalk-step--active');
    }

    // --- Termék változás ---
    $(document).on('change', '.js-product-select', function () {
        const $card = $(this).closest('.kalk-item');
        const $option = $(this).find('option:selected');
        const name  = $option.data('name')  || '';
        const img   = $option.data('image') || '';
        const qpmId = $option.data('qpm')   || null;
        const stId  = $option.data('sizetype') || null;
        let   sizes = $option.data('sizes')  || [];
        if (typeof sizes === 'string') {
            try { sizes = JSON.parse(sizes); } catch(e) { sizes = []; }
        }

        if (!$(this).val()) {
            $card.find('.js-product-preview').addClass('d-none');
            $card.find('.js-sizes-section').addClass('d-none');
            return;
        }

        // Preview megjelenítés
        $card.find('.js-preview-name').text(name);
        $card.find('.js-preview-img').attr('src', img).attr('alt', name);
        $card.find('.js-preview-price').text('–');
        $card.find('.js-product-preview').removeClass('d-none');

        // Méret sorok (adatbázisból származnak)
        buildSizeRows($card, sizes);

        updateSteps(sizes.length ? 2 : 3);
        triggerCalculation($card);
    });

    // --- Méret darabszám változás ---
    $(document).on('input change', '.js-size-qty-input', function () {
        const $card = $(this).closest('.kalk-item');
        triggerCalculation($card);
        updateSteps(4);
    });

    $(document).on('click', '.js-size-qty-minus', function () {
        const $input = $(this).siblings('.js-size-qty-input');
        const val = Math.max(0, parseInt($input.val(), 10) - 1);
        $input.val(val);
        triggerCalculation($(this).closest('.kalk-item'));
    });

    $(document).on('click', '.js-size-qty-plus', function () {
        const $input = $(this).siblings('.js-size-qty-input');
        const val = Math.min(9999, parseInt($input.val(), 10) + 1);
        $input.val(val);
        triggerCalculation($(this).closest('.kalk-item'));
    });

    // --- Termék hozzáadása gomb ---
    $('#kalkulatorAddItem').on('click', function () {
        const $items = $('#kalkulatorItems');
        const $template = $items.find('.kalk-item').first();
        const $clone = $template.clone(false);
        const newIndex = $items.find('.kalk-item').length;

        $clone.attr('data-item-index', newIndex);
        $clone.find('.js-sizes-section').addClass('d-none');
        $clone.find('.js-product-preview').addClass('d-none');
        $clone.find('.js-product-select').val('');
        $clone.find('.js-size-qty-input').val(0);
        $clone.find('.js-size-rows-container').empty();

        $items.append($clone);
    });

    // --- Kosárba gomb (kalkulátorból) ---
    $(document).on('click', '.js-add-to-cart', function (e) {
        e.preventDefault();
        const $option = $(this).closest('.kalk-item').find('.js-product-select option:selected');
        const slug = $option.data('slug') || null;
        if (slug) {
            window.location.href = '/product/' + slug;
        }
    });

    // --- Kalkulátor kosár: localStorage-alapú többtermékes előtöltés ---
    (function () {
        var CART_KEY = 'kalk_cart_ids';

        // 1. Terméklapon: "Ár kiszámítása" kattintáskor ID hozzáadása a kosárhoz
        $(document).on('click', '.product-kalk-block__btn', function () {
            var href = $(this).attr('href') || '';
            var match = href.match(/product_id=(\d+)/);
            if (!match) return;
            var pid = parseInt(match[1], 10);
            var cart = [];
            try { cart = JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch (ex) { }
            if (!cart.includes(pid)) cart.push(pid);
            localStorage.setItem(CART_KEY, JSON.stringify(cart));
            // A link normálisan navigál tovább
        });

        // 2. Kalkulátor oldalon: kosár tartalmának betöltése
        if (!$('#kalkulatorApp').length) return;

        // URL param is hozzáadódik a kosárhoz (visszafelé kompatibilis)
        var params = new URLSearchParams(window.location.search);
        var urlPid = parseInt(params.get('product_id'), 10) || null;

        var cart = [];
        try { cart = JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch (ex) { }

        if (urlPid && !cart.includes(urlPid)) {
            cart.push(urlPid);
            localStorage.setItem(CART_KEY, JSON.stringify(cart));
        }

        if (!cart.length) return;

        var $itemsWrap = $('#kalkulatorItems');

        cart.forEach(function (pid, index) {
            var $card;
            if (index === 0) {
                $card = $itemsWrap.find('.kalk-item').first();
            } else {
                var $tmpl = $itemsWrap.find('.kalk-item').first();
                var $clone = $tmpl.clone(false);
                $clone.attr('data-item-index', index);
                $clone.find('.js-sizes-section').addClass('d-none');
                $clone.find('.js-product-preview').addClass('d-none');
                $clone.find('.js-size-qty-input').val(0);
                $clone.find('.js-size-rows-container').empty();
                $itemsWrap.append($clone);
                $card = $clone;
            }

            var $sel = $card.find('.js-product-select');
            if ($sel.find('option[value="' + pid + '"]').length) {
                $sel.val(pid).trigger('change');
            }
        });
    })();

})(jQuery);

/**
 * Kalkulátor fiók (drawer)
 * Termék oldalakról hozzáadható kalkulátor – localStorage alapú kosár
 */
(function ($) {
    'use strict';

    var $drawer = null;
    var DRAWER_URL = '/kalkulator/price';
    var DRAWER_LOCALE = 'hu';
    var STORAGE_KEY = 'kalk_drawer_items';

    function getCart() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
        catch (e) { return []; }
    }

    function saveCart(items) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
        catch (e) { }
    }

    function fmtPrice(amount, currency) {
        if (amount == null) return '–';
        currency = currency || 'HUF';
        if (currency === 'HUF') {
            return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 }).format(amount);
        }
        return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(amount);
    }

    function esc(str) {
        return $('<div>').text(String(str || '')).html();
    }

    function openDrawer() {
        if (!$drawer || !$drawer.length) return;
        $drawer.addClass('is-open').attr('aria-hidden', 'false');
        $('body').addClass('kalk-drawer-open');
        renderCart();
    }

    function closeDrawer() {
        if (!$drawer || !$drawer.length) return;
        $drawer.removeClass('is-open').attr('aria-hidden', 'true');
        $('body').removeClass('kalk-drawer-open');
    }

    function renderCart() {
        var $body = $('#kalkDrawerBody');
        if (!$body.length) return;

        var items = getCart();

        if (!items.length) {
            var hint = DRAWER_LOCALE === 'hu'
                ? '<p class="kalk-drawer__empty-text">A kalkulátor kosara üres.</p><p class="kalk-drawer__empty-hint">Nyisd meg egy termék oldalát és kattints az &bdquo;Ár kiszámítása&rdquo; gombra!</p>'
                : '<p class="kalk-drawer__empty-text">The calculator is empty.</p><p class="kalk-drawer__empty-hint">Open a product page and click &ldquo;Calculate price&rdquo;!</p>';
            $body.html('<div class="kalk-drawer__empty">' + hint + '</div>');
            return;
        }

        var html = '';
        items.forEach(function (item, idx) {
            var imgHtml = item.image
                ? '<img src="' + esc(item.image) + '" alt="' + esc(item.name) + '" class="kalk-drawer__item-img" loading="lazy">'
                : '<div class="kalk-drawer__item-img kalk-drawer__item-img--empty"></div>';

            var sizesHtml = '';
            if (item.sizes && item.sizes.length) {
                sizesHtml += '<div class="kalk-drawer__item-field">';
                sizesHtml += '<span class="kalk-drawer__item-label">' + (DRAWER_LOCALE === 'hu' ? 'Méret' : 'Size') + '</span>';
                sizesHtml += '<div class="kalk-drawer__sizes">';
                item.sizes.forEach(function (size) {
                    var cls = item.size === size ? ' is-active' : '';
                    sizesHtml += '<button type="button" class="kalk-drawer__size-btn' + cls + '" data-idx="' + idx + '" data-size="' + esc(size) + '">' + esc(size) + '</button>';
                });
                sizesHtml += '</div></div>';
            }

            var priceText = item.unitPrice != null ? fmtPrice(item.unitPrice, item.currency) : '–';

            html += '<div class="kalk-drawer__item" data-idx="' + idx + '">';
            html += '<div class="kalk-drawer__item-header">';
            html += imgHtml;
            html += '<div class="kalk-drawer__item-meta">';
            html += '<span class="kalk-drawer__item-name">' + esc(item.name) + '</span>';
            html += '<span class="kalk-drawer__item-price js-drawer-price" data-idx="' + idx + '">' + priceText + '</span>';
            html += '</div>';
            html += '<button type="button" class="kalk-drawer__remove js-drawer-remove" data-idx="' + idx + '" aria-label="' + (DRAWER_LOCALE === 'hu' ? 'Eltávolítás' : 'Remove') + '">';
            html += '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
            html += '</button></div>';
            html += sizesHtml;
            html += '<div class="kalk-drawer__item-field">';
            html += '<span class="kalk-drawer__item-label">' + (DRAWER_LOCALE === 'hu' ? 'Darabszám' : 'Quantity') + '</span>';
            html += '<div class="kalk-qty-control">';
            html += '<button type="button" class="kalk-qty-btn js-drawer-minus" data-idx="' + idx + '">−</button>';
            html += '<input type="number" class="kalk-qty-input js-drawer-qty" data-idx="' + idx + '" value="' + (item.qty || 1) + '" min="1" max="9999">';
            html += '<button type="button" class="kalk-qty-btn js-drawer-plus" data-idx="' + idx + '">+</button>';
            html += '</div></div>';
            html += '</div>';
        });

        $body.html(html);
        items.forEach(function (_, idx) { calcDrawerPrice(idx); });
    }

    function calcDrawerPrice(idx) {
        var items = getCart();
        var item = items[idx];
        if (!item || !item.id) return;

        $.ajax({
            url: DRAWER_URL,
            method: 'POST',
            data: {
                product_id: item.id,
                size: item.size || null,
                quantity: item.qty || 1,
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            success: function (data) {
                var cur = getCart();
                if (!cur[idx]) return;
                cur[idx].unitPrice = data.unit_price;
                cur[idx].currency = data.currency || 'HUF';
                saveCart(cur);
                $('.js-drawer-price[data-idx="' + idx + '"]').text(fmtPrice(data.unit_price, data.currency));
            },
        });
    }

    function addToDrawer(productData) {
        var items = getCart();
        var exists = items.some(function (it) { return String(it.id) === String(productData.id); });
        if (!exists) {
            items.push({
                id: productData.id, name: productData.name || '', image: productData.image || '',
                price: productData.price || 0, sizes: productData.sizes || [],
                qty: 1, size: null, unitPrice: null, currency: 'HUF',
            });
            saveCart(items);
        }
        openDrawer();
    }

    $(document).ready(function () {
        $drawer = $('#kalkDrawer');
        if (!$drawer.length) return;

        DRAWER_URL = $drawer.data('price-url') || DRAWER_URL;
        DRAWER_LOCALE = $drawer.data('locale') || DRAWER_LOCALE;

        $(document).on('click', '.js-kalk-open-drawer', function () {
            var d = window._kalkProductData;
            if (!d || !d.id) return;
            addToDrawer(d);
        });

        $(document).on('click', '.js-kalk-backdrop, .js-kalk-close', function () { closeDrawer(); });
        $(document).on('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

        $(document).on('click', '.js-drawer-remove', function () {
            var idx = parseInt($(this).data('idx'), 10);
            var items = getCart();
            items.splice(idx, 1);
            saveCart(items);
            renderCart();
        });

        $(document).on('click', '.kalk-drawer__size-btn', function () {
            var idx = parseInt($(this).data('idx'), 10);
            var size = String($(this).data('size'));
            var items = getCart();
            if (!items[idx]) return;
            items[idx].size = size;
            saveCart(items);
            $('.kalk-drawer__item[data-idx="' + idx + '"] .kalk-drawer__size-btn').removeClass('is-active');
            $(this).addClass('is-active');
            calcDrawerPrice(idx);
        });

        $(document).on('click', '.js-drawer-minus', function () {
            var idx = parseInt($(this).data('idx'), 10);
            var $i = $('.js-drawer-qty[data-idx="' + idx + '"]');
            var val = Math.max(1, (parseInt($i.val(), 10) || 1) - 1);
            $i.val(val);
            var items = getCart();
            if (items[idx]) { items[idx].qty = val; saveCart(items); calcDrawerPrice(idx); }
        });

        $(document).on('click', '.js-drawer-plus', function () {
            var idx = parseInt($(this).data('idx'), 10);
            var $i = $('.js-drawer-qty[data-idx="' + idx + '"]');
            var val = Math.min(9999, (parseInt($i.val(), 10) || 1) + 1);
            $i.val(val);
            var items = getCart();
            if (items[idx]) { items[idx].qty = val; saveCart(items); calcDrawerPrice(idx); }
        });

        $(document).on('change', '.js-drawer-qty', function () {
            var idx = parseInt($(this).data('idx'), 10);
            var val = Math.max(1, Math.min(9999, parseInt($(this).val(), 10) || 1));
            $(this).val(val);
            var items = getCart();
            if (items[idx]) { items[idx].qty = val; saveCart(items); calcDrawerPrice(idx); }
        });
    });

})(jQuery);
